import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Engagement from './components/Engagement';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AIToolsetDevelopment from './components/AIToolsetDevelopment';
import PrivacyPolicy from './components/PrivacyPolicy';
import FinanceIntelligence from './components/FinanceIntelligence';
import OpsTriageIntelligence from './components/OpsTriageIntelligence';
import BespokeOrchestration from './components/BespokeOrchestration';
import AboutPage from './components/AboutPage';

function App() {
  // Set to true when ready to show testimonials
  const showTestimonials = false;
  
  // Set to true when ready to show trust indicators (client logos, trusted by section)
  const showTrustIndicators = false;

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={
          <>
            <Navbar showTestimonials={showTestimonials} />
            <Hero showTrustIndicators={showTrustIndicators} />
            <Services />
            <Engagement />
            {showTestimonials && <Testimonials />}
            <Contact />
            <Footer showTestimonials={showTestimonials} />
          </>
        } />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/ai-toolset-development" element={<AIToolsetDevelopment />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/finance-intelligence" element={<FinanceIntelligence />} />
        <Route path="/operational-intelligence" element={<OpsTriageIntelligence />} />
        <Route path="/bespoke-orchestration" element={<BespokeOrchestration />} />
      </Routes>
    </div>
  );
}

export default App;